import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to indicate progress in some process as round progress bar.
 */
var RoundProgressBarComponent = /** @class */ (function (_super) {
    __extends(RoundProgressBarComponent, _super);
    function RoundProgressBarComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RoundProgressBarComponent.prototype, "progressValue", {
        /**
         * Make sure progress is a number between 0 and 100
         */
        get: function () {
            var progress = Math.round(Number(this.progress) || 0);
            if (progress < 0) {
                progress = 0;
            }
            if (progress > 100) {
                progress = 100;
            }
            return progress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoundProgressBarComponent.prototype, "isComplete", {
        get: function () {
            return this.progressValue === 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RoundProgressBarComponent.prototype, "styles", {
        get: function () {
            if (!this.progressValue) {
                return {};
            }
            return {
                '--magic-round-progress-bar-fill-percent': "" + this.progressValue,
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], RoundProgressBarComponent.prototype, "progress", void 0);
    RoundProgressBarComponent = __decorate([
        Component({
            name: 'ui-round-progress-bar',
        })
    ], RoundProgressBarComponent);
    return RoundProgressBarComponent;
}(Mixins(MagicConfigMixin)));

export default RoundProgressBarComponent;
